import { lazy, Suspense } from 'react'
import { Loading } from '~/components/Loading'

import type { PdfViewerProps } from './PdfViewer'

const PdfViewer = lazy(() =>
  import('./PdfViewer').then((module) => ({ default: module.PdfViewer })),
)

export const LazyPdfViewer = (props: PdfViewerProps) => (
  <Suspense fallback={<Loading />}>
    <PdfViewer {...props} />
  </Suspense>
)
